import { render, staticRenderFns } from "./MoleculeImageThumbSlider.vue?vue&type=template&id=70ccf4fa&"
import script from "./MoleculeImageThumbSlider.vue?vue&type=script&lang=js&"
export * from "./MoleculeImageThumbSlider.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeImageThumbSlider.vue?vue&type=style&index=0&id=70ccf4fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonSliderAtomImageThumbSlider: require('/app/components/atoms/common/slider/AtomImageThumbSlider.vue').default})
